/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {useAuth} from '../../modules/auth'
import PleasureSpotCompletionPage from './PleasureSpotCompletionPage'

const PleasureSpotCompletionWrapper: FC = () => {
  const {currentUser} = useAuth()

  return (
    <>
      <div className='d-flex justify-content-between align-items-center mt-3 ms-3 me-3'>
        <h1>
          Data Completion – {currentUser?.decoded?.current_shopify_store || 'No Store Selected'}
        </h1>
      </div>
      <PleasureSpotCompletionPage />
    </>
  )
}

export default PleasureSpotCompletionWrapper


